import {alertValidation} from "../util/alertValidation";
import {exhibitionAlertSuccess} from "../util/exhibitionAlertSuccess";

export const exhibitionServerValidation = (response, history, dispatch, type) => {
    switch (response.data.message) {
        case "exhibitionRoom_001"
        : alertValidation('업데이트 하려는 전시관 데이터가 없습니다.');
            return false;
        case "exhibitionRoom_002"
        : alertValidation('일반 해설자를 선택해주세요.');
            return false;
        case "exhibitionRoom_003"
        : alertValidation('어린이 해설사를 선택해주세요.');
            return false;
        case "exhibitionRoom_004"
        : alertValidation('시각장애인용 해설자를 선택해주세요.');
            return false;
        case "exhibitionRoom_005"
        : alertValidation('연관 데이터를 선택해주세요.');
            return false;
        case "exhibitionRoom_006"
        : alertValidation('전시관 언어 설정이 잘못되었습니다.');
            return false;
        case "exhibitionRoom_009"
        : alertValidation('활성화된 전시관이 3개 이상입니다.\n다른 전시관을 비활성화 해주세요.');
            return false;
        case "roomSubTopic_001"
        : alertValidation('중주제 제목을 입력해주세요.');
            return false;
        case "roomSubTopic_002"
        : alertValidation('수정하려는 중제목의 데이터가 없습니다.');
            return false;
        case "serverError"
        : alertValidation('관리자에게 문의해주세요.');
            return false;
        default : exhibitionAlertSuccess('저장', true, history, dispatch, type);
            break;
    }
}